RivalIQ.module('views', function (views, App, Backbone, Marionette, $, _, d3, s) {

    'use strict';

    views.TableColumn = Marionette.ItemView.extend({
        events: {
            'click': 'onClick'
        },

        template: false,

        maxExportValueLength: 300,

        tagName: function () {

            const me = this;
            return (me.isHeader() ? 'th' : 'td');
        },

        className: function () {

            const me = this;
            let className;
            const model = me.model;
            const options = me.options;

            if (_.has(options, 'className')) {

                className = options.className;
            } else if (model && model.has('className')) {

                className = model.get('className');
            }

            return className;
        },

        attributes: function () {

            const me = this;
            const attributes = me.model.get('attributes');
            return (me.isHeader() ? _.omit(attributes, 'title') : attributes);
        },

        onAttach: function () {

            const me = this;
            const model = me.model;

            me.$el.html(me.getHtml(model.get('value')));
            me.initializeTooltip();
        },

        initializeTooltip: function () {

            const me = this;
            const attributes = me.model.get('attributes');

            if (!me.isHeader() || !_.has(attributes, 'title')) {

                return;
            }

            const config = _.extend({
                class: [
                    'fa',
                    'fa-fw',
                    'fa-info-circle',
                    'fa-color',
                    'pointer',
                    'x-export-hide'
                ]
            }, _.pick(attributes, 'title'));

            $($.tagHtml('span', config)).appendTo(me.el).tooltip({
                container: 'body'
            });
        },

        getFormatter: function (config) {

            const me = this;
            let formatter = null;
            let originalFormatter = null;
            const maxExportValueLength = me.getOption('maxExportValueLength');

            const defaultFormatter = function (val) {

                if (RivalIQ.state.view.get('isExport') && _.isString(val) && _.isNumber(maxExportValueLength)) {

                    return s.prune(val, maxExportValueLength);
                }

                return val;
            };

            if (config.formatter) {

                formatter = originalFormatter = config.formatter;
            } else if (config.model && config.model.has('formatter')) {

                formatter = originalFormatter = config.model.get('formatter');
            }

            if (_.isString(formatter)) {

                formatter = function (value) {

                    return d3.format(originalFormatter)(value);
                };
            }

            return formatter || defaultFormatter;
        },

        getHtml: function (value) {

            const me = this;
            let result = value;
            const formatter = me.getFormatter(me.options);

            if (_.isFunction(value)) {

                result = value();

                if (result && result.render) {

                    return result.render().$el;
                }
            }

            return formatter(result, me.model.get('data'));
        },

        onClick: function () {

            let handler;
            const me = this;
            const model = me.model;
            const options = me.options;

            if (options.onClick) {

                handler = options.onClick;
            } else if (model && model.has('onClick')) {

                handler = model.get('onClick');
            }

            // we must destroy tooltips if they exist, otherwise it is possible
            // that they will stick around forever after clicking
            me.destroyTooltips();

            if (_.isFunction(handler)) {

                return handler(me);
            }
        },

        destroyTooltips: function () {

            $('.tooltip').remove();
        },

        isHeader: function () {

            const me = this;
            return (me.getOption('isHeader') === true);
        }
    });

}, window.d3, window.s);
